import React from "react";
import { Grid } from "semantic-ui-react";
import CheckboxCard from "./CheckboxCard";

const StepTwoCheckbox = () => (
  <Grid>
    <Grid.Row>
      <Grid.Column>
        <CheckboxCard Text="Recite all the verses you took for the first half of the page all together while only looking at the Quran when you need to" Note="If you get stuck at all, look at the Quran immediately. We do not want any hesitation in our recitations. Highlight where you get stuck, it will be the same place every time. Create a ‘trick’ to help you not get stuck there. " Count="10" />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column>
        <CheckboxCard Text="Test yourself, must be able to recite verse 3 times in a row without any mistakes" Note="You should be able to read all the verses in English, without thinking of the Arabee. You should be thinking of the ‘Grouping’ of the verses." Count="3" />
      </Grid.Column>
    </Grid.Row>
  </Grid>
)
export default StepTwoCheckbox;